import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslationApp } from "../../../lib/i18next";
import {
  BULK_CAMPAIGNS_LIST_TITLE,
  BULK_CAMPAIGNS_SUMMARY,
  BULK_CAMPAIGNS_SUMMARY_COUNT,
} from "../../../i18n/keysTranslations";
import { getBulkCampaignTypeConfig } from "./bulkCampaignTypes";
import { readArray } from "./bulkCampaignModel";

const BulkCampaignSummary = ({ review }) => {
  const { t } = useTranslationApp();
  const campaigns = readArray(review?.campaigns);
  const values = getBulkCampaignTypeConfig({
    platform: review?.platform,
    campaignType: review?.campaignType,
  }).getSummaryValues(campaigns);
  const summaryKey =
    values.maxAdGroups != null
      ? BULK_CAMPAIGNS_SUMMARY
      : BULK_CAMPAIGNS_SUMMARY_COUNT;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Typography variant="body1">
        {t(summaryKey, { ...values, count: values.campaigns })}
      </Typography>
      <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
        {t(BULK_CAMPAIGNS_LIST_TITLE)}
      </Typography>
      <Box
        component="ul"
        sx={{
          m: 0,
          pl: 3,
          maxHeight: 280,
          overflowY: "auto",
          listStyleType: "disc",
        }}
      >
        {campaigns.map((campaign, index) => (
          <Typography
            component="li"
            variant="body2"
            key={`${campaign?.name ?? "campaign"}-${index}`}
            sx={{ py: 0.25, display: "list-item" }}
          >
            {campaign?.name}
          </Typography>
        ))}
      </Box>
    </Box>
  );
};

export default BulkCampaignSummary;
